import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/tema_light/view_main.vue"),
  },
  {
    path: "/jornada/:nombre_seo_participante",
    name: "ficha_jornada_participante",
    component: () => import("@/views/tema_light/view_ficha_participante.vue"),
  },

  {
    path: "/textos-legales",
    name: "",
    component: () => import("@/layouts/tema_light/textos_layout.vue"),
    children: [
      {
        path: "/textos-legales/:url_texto",
        name: "texto-legal",
        component: () => import("@/views/tema_light/view_texto_legal.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }

    return { top: 0 };
  },
});

export default router;
